import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../../contex/AuthProvider';
import toast from 'react-hot-toast';
import { useQuery } from '@tanstack/react-query';
import Loading from '../../../Home/Share/Loading/Loading';

const AllUser = () => {
    const { user, logOut } = useContext(AuthContext);
    // const [orders, setOrders] = useState([]);

    const { data: orders = [], isLoading, refetch } = useQuery({
        queryKey: ['orders'],
        queryFn: async () => {
            const res = await fetch('https://assignment-12-server-imraniium-su.vercel.app/users', {
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            });
            const data = await res.json();
            return data;
        }
    });
    if (isLoading) {
        return <Loading></Loading>
    }


    const handleDelete = (id) => {
        const proceed = window.confirm('Are you sure, you want to cancel this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/users/${id}`, {
                method: 'DELETE',
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            })
                .then(res => {
                    res.json()
                })
                .then(data => {
                    refetch()
                    toast.success('Successfully delete');
                    console.log(data);
                })
        }
    }

    const handleAdmin = id => {
        fetch(`https://assignment-12-server-imraniium-su.vercel.app/users/admin/${id}`, {
            method: 'PUT',
            headers: {
                authorization: `bearer ${localStorage.getItem('accessToken')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.modifiedCount > 0) {
                    toast.success('Make admin successful')

                }
            })
    }

    return (
        <div>

            <h3 className='text-3xl font-semibold mb-5 text-center'>All seller</h3>


            <div className="overflow-x-auto m-3">
                <table className="table w-full">

                    <thead>
                        <tr>
                            <th></th>

                            <th>Name</th>
                            <th>Email</th>
                            <th>Admin</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            orders &&
                            orders?.map((book, i) => <tr key={book._id}>
                                <th>{i + 1}</th>
                                <td>{book.name}</td>
                                <td>{book.email}</td>
                                <td>
                                    {book?.role !== 'admin' && <button onClick={() => handleAdmin(book._id)} className='btn btn-xs btn-primary'>Make Admin</button>}
                                </td>


                                <td>
                                    <label>
                                        <button onClick={() => handleDelete(book._id)} className='btn btn-primary btn-sm'>Delete</button>
                                    </label>
                                </td>


                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AllUser;